// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7e881269","732":"2ce71ec1","977":"fd4e7304"}[chunkId] + ".chunk.js";
};